import swiper from 'swiper';

$('.js-imageSlider').each(function(i, v) {
  var $that = $(this);

  let slide = $that.find(".swiper-slide").length;
  // $that.find(".swiper-slide").length;

if(slide > 1) {

  var topExhibitionList = new swiper ($that, {
    direction: 'horizontal',
    loop: true,
    // slidesPerView: 5,
    autoplay: 5e3,
    spaceBetween: 40,
    centeredSlides: true,
    observer: true,
    autoplay: {
      delay: 4000
    },
    breakpoints: {
      768: {
        spaceBetween: 0
      }
    },
    // observeParents: true,
    preloadImages: false,
    slidesPerView: "auto",
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 4
    },
    pagination: {
      el: '.swiper-imageSlider-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '"></span>';
      },
    },

    // Navigation arrows
    // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev',
      // },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },

    });
}
});
